import classNames from 'classnames';

import { ModalDialogType, ModalDialogProps, ModalDialogSizes } from '../ModalDialogTypes';

const sizeClassNames = (modalSize: ModalDialogSizes = 'medium') => {
    switch (modalSize) {
        case 'wide':
            return 'sgw-modal-dialog__wide';
        case 'large':
            return 'sgw-modal-dialog__large';
        case 'medium':
        default:
            return 'sgw-modal-dialog__medium';
    }
};

const typeClassNames = (modalType: ModalDialogType = 'standard') => {
    switch (modalType) {
        case 'sub':
            return 'sgw-modal-dialog__sub';
        case 'standard':
        default:
            return '';
    }
};

const animateClassNames = (modalTypes?: ModalDialogType): string | null => {
    if (modalTypes) {
        switch (modalTypes) {
            case 'sub':
                return 'animate-as-sub';
            case 'standard':
            default:
                return 'animate-as-standard';
        }
    }
    return null;
};

const getModalDialogClassNames = (ownProps: ModalDialogProps) => {
    const modalTypeClassName = typeClassNames(ownProps.type);
    const sizeClassName = sizeClassNames(ownProps.size);
    const growClassName = ownProps.growWithContent ? 'sgw-modal-dialog__grow-with-content' : '';
    const animateAs = animateClassNames(ownProps.animateAs);

    return classNames(modalTypeClassName, sizeClassName, growClassName, animateAs);
};

export default getModalDialogClassNames;
